import {
  ActionIcon,
  Avatar,
  Box,
  Button,
  Group,
  Loader,
  Menu,
  Text,
} from "@mantine/core";
import {
  IconCash,
  IconChevronDown,
  IconLogout,
  IconRefresh,
  IconSettings,
  IconUser,
  IconWallet,
} from "@tabler/icons-react";
import { useAtomValue } from "jotai";
import { Link } from "react-router-dom";
import { userInfoAtom } from "../../atoms";
import { useUserBalance } from "../../hooks/useUserBalance";

interface UserMenuProps {
  handleLogout: () => void;
  onTransferClick: () => void;
}

export function UserMenu({ handleLogout, onTransferClick }: UserMenuProps) {
  const userInfo = useAtomValue(userInfoAtom);
  const { balance, loading, refetch } = useUserBalance();

  const profileUrlPath = userInfo?.brandId ?? userInfo?.email;

  return (
    <Menu position="bottom-end" shadow="md" width={200}>
      <Menu.Target>
        <Group gap="xs" wrap="nowrap" style={{ cursor: "pointer" }}>
          <Avatar
            // src={userInfo?.profileImage}
            radius="xl"
            size="md"
            color="blue"
          >
            {userInfo?.email?.charAt(0).toUpperCase() || "U"}
          </Avatar>
          {userInfo?.userType === "CREATOR" && balance > 0 ? (
            <Text c={"green"} fw={500} style={{ whiteSpace: "nowrap" }}>
              {new Intl.NumberFormat("en-US", {
                style: "currency",
                currency: "USD",
              }).format(balance)}
            </Text>
          ) : null}
          <IconChevronDown />
        </Group>
      </Menu.Target>
      <Menu.Dropdown>
        <Box px="md" py="sm">
          <Text size="sm" fw={500} truncate>
            {userInfo?.email || "User"}
          </Text>
          {userInfo?.userType === "CREATOR" ? (
            <Box>
              <Group gap={4} mt="sm" align="center" wrap="nowrap">
                <IconWallet size={18} />
                <Text>Balance:</Text>
                {loading ? (
                  <Loader size="xs" />
                ) : (
                  <Text c={"green"} fw={500} style={{ whiteSpace: "nowrap" }}>
                    {new Intl.NumberFormat("en-US", {
                      style: "currency",
                      currency: "USD",
                    }).format(balance)}
                  </Text>
                )}
                <ActionIcon
                  size="sm"
                  variant="subtle"
                  onClick={refetch}
                  disabled={loading}
                  title="Refresh balance"
                >
                  <IconRefresh size={14} />
                </ActionIcon>
              </Group>
              <Button
                variant="outline"
                size="xs"
                mt="xs"
                onClick={onTransferClick}
                leftSection={<IconCash size={14} />}
                disabled={balance === 0}
              >
                Transfer
              </Button>
            </Box>
          ) : null}
        </Box>
        <Menu.Divider />
        <Menu.Item
          leftSection={<IconUser size={14} />}
          component={Link}
          to={`/profile/${profileUrlPath}`}
        >
          Profile
        </Menu.Item>
        <Menu.Item leftSection={<IconSettings size={14} />}>
          Settings (Coming soon)
        </Menu.Item>
        <Menu.Divider />
        <Menu.Item
          leftSection={<IconLogout size={14} />}
          color="red"
          onClick={handleLogout}
        >
          Logout
        </Menu.Item>
      </Menu.Dropdown>
    </Menu>
  );
}
